import { lazy } from "react";
import type { RouteObject } from "react-router";

const AdminIndex = lazy(() => import("@/app/(main)/admin/page"));
const D1Overview = lazy(() => import("@/app/(main)/admin/d1/page"));
const Modules = lazy(() => import("@/app/(main)/admin/modules/page"));

// Tenants
const Tenants = lazy(() => import("@/app/(main)/admin/tenants/page"));
const TenantDetail = lazy(() => import("@/app/(main)/admin/tenants/[id]/page"));

// Users
const Users = lazy(() => import("@/app/(main)/admin/users/page"));
const UserDetail = lazy(() => import("@/app/(main)/admin/users/[id]/page"));

// AI Providers
const AiProviders = lazy(() => import("@/app/(main)/admin/ai-providers/page"));
const AiProviderModels = lazy(() => import("@/app/(main)/admin/ai-providers/models/page"));

export const adminRoutes: RouteObject[] = [
  { index: true, Component: AdminIndex },
  { path: "d1", Component: D1Overview },
  { path: "modules", Component: Modules },

  // Tenants
  { path: "tenants", Component: Tenants },
  { path: "tenants/:id", Component: TenantDetail },

  // Users
  { path: "users", Component: Users },
  { path: "users/:id", Component: UserDetail },

  // AI Providers
  { path: "ai-providers", Component: AiProviders },
  { path: "ai-providers/models", Component: AiProviderModels },
];
